export default "__VITE_ASSET__cd230182__"